import React from 'react';
import './EtapeCoordonnees.css';

export default function EtapeCoordonnees({ coordonnees, onChange, erreurs }) {
  function set(k, v) {
    onChange({ ...coordonnees, [k]: v });
  }

  return (
    <div className="etape-coordonnees">
      <div className="etape-intro">
        <p className="muted">Vos informations de contact pour recevoir votre confirmation.</p>
      </div>

      <div className="coord-form">
        <div className="coord-row">
          <div className="coord-group">
            <label htmlFor="prenom">Prénom <span className="requis">*</span></label>
            <input
              id="prenom"
              type="text"
              value={coordonnees.prenom || ''}
              onChange={e => set('prenom', e.target.value)}
              placeholder="Jean"
              autoComplete="given-name"
              className={erreurs?.prenom ? 'input-erreur' : ''}
            />
            {erreurs?.prenom && <div className="champ-erreur">{erreurs.prenom}</div>}
          </div>
          <div className="coord-group">
            <label htmlFor="nom">Nom <span className="requis">*</span></label>
            <input
              id="nom"
              type="text"
              value={coordonnees.nom || ''}
              onChange={e => set('nom', e.target.value)}
              placeholder="Tremblay"
              autoComplete="family-name"
              className={erreurs?.nom ? 'input-erreur' : ''}
            />
            {erreurs?.nom && <div className="champ-erreur">{erreurs.nom}</div>}
          </div>
        </div>

        <div className="coord-group">
          <label htmlFor="courriel">Courriel <span className="requis">*</span></label>
          <input
            id="courriel"
            type="email"
            inputMode="email"
            value={coordonnees.courriel || ''}
            onChange={e => set('courriel', e.target.value)}
            placeholder="jean.tremblay@exemple.com"
            autoComplete="email"
            className={erreurs?.courriel ? 'input-erreur' : ''}
          />
          {erreurs?.courriel && <div className="champ-erreur">{erreurs.courriel}</div>}
        </div>

        <div className="coord-group">
          <label htmlFor="telephone">Téléphone <span className="muted">(optionnel)</span></label>
          <input
            id="telephone"
            type="tel"
            inputMode="tel"
            value={coordonnees.telephone || ''}
            onChange={e => set('telephone', e.target.value)}
            placeholder="418 555-0100"
            autoComplete="tel"
          />
        </div>

        <div className="coord-group">
          <label htmlFor="notes">Notes <span className="muted">(allergies, demandes spéciales…)</span></label>
          <textarea
            id="notes"
            value={coordonnees.notes || ''}
            onChange={e => set('notes', e.target.value)}
            rows={3}
            placeholder="Ex : allergie aux arachides, plateau sans saucisses…"
          />
        </div>
      </div>
    </div>
  );
}
